import { useCallback } from 'react';
import { matchSorter } from 'match-sorter';
import type { SyntheticEvent } from 'react';

import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import type { AutocompleteRenderInputParams } from '@mui/material/Autocomplete';

interface Props {
  readonly id: string;
  readonly label: string;
  readonly onChange: (values: readonly string[]) => void;
  readonly suggestions: readonly string[];
  readonly required?: boolean;
  readonly value: readonly string[];
}

// Free texts, the suggestions (reference labels) only easing their typing.
export const FreeTextMultiAutocomplete = ({
  id,
  label,
  onChange,
  required = false,
  suggestions,
  value,
}: Readonly<Props>) => {
  const handleChange = useCallback(
    (_event: SyntheticEvent, values: readonly string[]) => {
      onChange(values.map((text) => text.trim()).filter((text) => !!text));
    },
    [onChange],
  );

  const filterOptions = useCallback(
    (options: string[], { inputValue }: Readonly<{ inputValue: string }>) =>
      matchSorter(options, inputValue),
    [],
  );

  const renderInput = useCallback(
    (params: Readonly<AutocompleteRenderInputParams>) => (
      <TextField
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...params}
        fullWidth
        label={label}
        placeholder="Choisir ou saisir"
        required={required}
      />
    ),
    [label, required],
  );

  return (
    <Autocomplete<string, true, false, true>
      autoSelect
      filterOptions={filterOptions}
      freeSolo
      id={id}
      multiple
      onChange={handleChange}
      options={[...suggestions]}
      renderInput={renderInput}
      slotProps={{ chip: { size: 'small', variant: 'outlined' } }}
      value={[...value]}
    />
  );
};
